import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../Base/Components/BaseModal/BaseModal';
import DefaultSettings from './DefaultSettings';

const DefaultSettingsModal: React.FC<BaseModalProps> = props => {
	return (
		<BaseModal {...props} title='component.defaultSettings.modalTitle'>
			<DefaultSettings onSave={() => props.onClose()} />
		</BaseModal>
	);
};

export default DefaultSettingsModal;
